import React from "react";
import ParkkiTheme from "themes/ParkkiTheme";
import styled from "@emotion/styled";

const HeaderContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
`;

const ContentContainer = styled.main`
  max-width: 1400px;
  margin: 0 auto;
  padding: 80px ${ParkkiTheme.spacings.tiny} 0;
`;

const FooterContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
`;

type Props = {
  content: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
};

function MainLayout({ content, footer, header }: Props): JSX.Element {
  return (
    <div>
      <HeaderContainer>{header}</HeaderContainer>
      <ContentContainer>{content}</ContentContainer>
      <FooterContainer>{footer}</FooterContainer>
    </div>
  );
}

export default MainLayout;
